// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lVhTE","fullView":"styles_fullView__qTPBj"};